/**
 * Global Logger Utility
 * Suppresses console logs in production environment for security and performance.
 */

const isProd = import.meta.env.PROD;

export const logger = {
  log: (...args: unknown[]) => {
    if (!isProd) {
      console.log(...args);
    }
  },
  info: (...args: unknown[]) => {
    if (!isProd) {
      console.info(...args);
    }
  },
  warn: (...args: unknown[]) => {
    // Warnings are kept in production but potentially filtered
    console.warn(...args);
  },
  error: (...args: unknown[]) => {
    // Errors are always kept for debugging production issues
    console.error(...args);
  },
  debug: (...args: unknown[]) => {
    if (!isProd) {
      console.debug(...args);
    }
  },
};

interface WindowWithConsole extends Window {
  console: Console;
}

// Auto-patch console in production
if (isProd) {
  const noop = () => {};
  const originalWarn = console.warn;
  const originalError = console.error;

  (window as WindowWithConsole).console.log = noop;
  (window as WindowWithConsole).console.debug = noop;
  (window as WindowWithConsole).console.info = noop;

  (window as WindowWithConsole).console.warn = (...args: unknown[]) => {
    originalWarn.apply(console, args);
  };

  (window as WindowWithConsole).console.error = (...args: unknown[]) => {
    originalError.apply(console, args);
  };
}
